import { createSlice } from "@reduxjs/toolkit";

const formSliceForm = createSlice({
	name: "form",
	initialState: {},
	reducers: {
		simcardPurchase: (state, action) => {
			return { ...state, ...action.payload };
		},
		clearFormData: (state, action) => {
			// از action.payload استفاده می‌کنیم تا بخش‌های مشخص شده را حذف کنیم
			const fieldsToRemove = action.payload || [];
			const newState = { ...state };

			fieldsToRemove.forEach((field) => {
				delete newState[field];
			});

			return newState;
		},
	},
});

export const { simcardPurchase, clearFormData } = formSliceForm.actions;

export default formSliceForm.reducer;
